import Autocomplete from "./autocomplete";

class Filtre {
    static init() {

        this.blocs = document.querySelectorAll(".flexlistedocument");


        if (typeof (json_press) !== "undefined") {
            fetch(json_press)
                .then(response => response.json())
                .then(json => {
                    // this.data = json;
                    // console.log(json);
                    this.hasCommunique = document.querySelector('.flexlistedocument__results').getAttribute('data-communique');
                    this.valueCommunique = document.querySelector('.flexlistedocument__results').getAttribute('data-filtrecommunique');
                    this.data = [];
                    if (this.hasCommunique === "true") {
                        json.forEach(obj => {
                            if(obj.theme.indexOf(this.valueCommunique ) > -1){
                                this.data.push(obj)
                            }
                        })
                    } else {
                        json.forEach(obj => {
                            if(obj.theme.indexOf(this.valueCommunique ) == -1){
                                this.data.push(obj)
                            }
                        })
                    }
                    this.blocs.forEach(bloc => {
                        bloc.filtreData = {};
                        bloc.currentPage = 0;
                        bloc.NB_ITEMS_PER_PAGE = bloc.dataset.nbitems;
                        bloc.resultatLabel = document.querySelector(".flexlistedocument__results");

                        bloc.box = bloc.querySelector(".flexlistedocument__contenu");
                        bloc.filtres = bloc.querySelectorAll(".flexlistedocument__filtre__liste");
                        bloc.ctaMore = bloc.querySelector(".flexlistedocument__plus button");

                        bloc.autocompletes = bloc.querySelectorAll(".autocomplete");
                        bloc.autocompletes.forEach(autocomplete => {
                            autocomplete.loupe = autocomplete.querySelector("button");
                            autocomplete.job = new Autocomplete(autocomplete, bloc, autocomplete.dataset.filtre, (bloc, filtre) => this.getResult(bloc, filtre), (value) => {
                                bloc.currentPage = 0;
                                bloc.filtreData[autocomplete.dataset.filtre] = (elem) => this.normalise(elem).indexOf(this.normalise(value)) > -1;
                                this.render(bloc);
                            }, autocomplete.loupe)
                            bloc.filtreData[autocomplete.dataset.filtre] = "";
                        });
                        bloc.filtres.forEach(thisFiltre => {

                            if (thisFiltre.dataset.filtre) {
                                let label = thisFiltre.dataset.filtre;
                                bloc.filtreData[label] = "";

                                thisFiltre["data_" + label] = [];

                                this.data.forEach(item => {
                                    if (item[label]) {
                                        if (item[label].indexOf(',') !== -1) {
                                            let arr = item[label].split(',');
                                            arr.forEach(item => {
                                                thisFiltre["data_" + label].indexOf(item) === -1 ? thisFiltre["data_" + label].push(item) : null;
                                            });
                                        } else {
                                            thisFiltre["data_" + label].indexOf(item[label]) === -1 ? thisFiltre["data_" + label].push(item[label]) : null;
                                        }
                                    }
                                })


                                thisFiltre["data_" + label].forEach(entry => {
                                    let li = document.createElement("li");
                                    li.classList.add("flexlistedocument__filtre__item");
                                    li.innerHTML = entry;
                                    li.dataset[label] = entry;
                                    thisFiltre.appendChild(li);
                                })
                            }

                            thisFiltre.items = thisFiltre.querySelectorAll(".flexlistedocument__filtre__item");
                            thisFiltre.items.forEach(item => {
                                item.addEventListener("click", () => {
                                    if (thisFiltre.classList.contains("flexlistedocument__filtre__liste--open")) {
                                        bloc.filtreData[thisFiltre.dataset.filtre] = item.dataset[thisFiltre.dataset.filtre];
                                        bloc.currentPage = 0;
                                        thisFiltre.items.forEach(item => item.classList.remove("flexlistedocument__filtre__item--current"));
                                        item.classList.add("flexlistedocument__filtre__item--current");
                                        thisFiltre.classList.remove("flexlistedocument__filtre__liste--open");

                                        this.render(bloc);
                                    } else {
                                        thisFiltre.classList.add("flexlistedocument__filtre__liste--open");
                                    }
                                })
                            })
                        });

                        if (bloc.ctaMore) {
                            bloc.ctaMore.addEventListener("click", () => {
                                bloc.currentPage++;
                                this.render(bloc);
                            })
                        }

                        this.render(bloc);
                    });
                })
        }
    }

    static getResult(bloc, filtre) {
        let result = this.data.filter(item => {
            let valide = true;
            for (let key in bloc.filtreData) {

                if (key !== filtre) {
                    if (typeof (bloc.filtreData[key]) === "function") {
                        valide = valide && bloc.filtreData[key](item[key]);
                    } else {
                        if (item[key].indexOf(',') !== -1 && key === 'theme') {
                            let arr = item[key].split(',');
                            let test = [];
                            arr.forEach((item) => {
                                (valide && (bloc.filtreData[key] === "" || item === bloc.filtreData[key])) ? test.push('true') : test.push('false');
                            });
                            if (test.indexOf('true') !== -1) {
                                valide = true;
                            } else {
                                valide = false;
                            }
                        } else {
                            valide = valide && (bloc.filtreData[key] === "" || item[key] === bloc.filtreData[key]);
                        }
                    }
                }
            }
            return valide;
        })

        return result;
    }

    static render(bloc) {
        if (bloc.currentPage === 0) {
            bloc.box.innerHTML = "";
            bloc.liste = document.createElement("ul");
            bloc.liste.classList.add("flexlistedocument__liste");
            bloc.box.appendChild(bloc.liste);
        }

        this.results = this.getResult(bloc);
        let textCta = "";
        if (document.documentElement.lang === "fr-FR") {
            textCta = "Télécharger <br>le document"
        } else {
            textCta = "Download <br>the file"
        }

        this.results.filter((item, index) => index >= bloc.currentPage * bloc.NB_ITEMS_PER_PAGE && index < (bloc.currentPage + 1) * bloc.NB_ITEMS_PER_PAGE).forEach(item => {
            let li = document.createElement("li");
            li.classList.add("flexlistedocument__item");

            li.innerHTML = `
                    <li class="flexlistedocument__item" data-annee="2014">
                        <p class="flexlistedocument__date">${item.date_transform}</p>
                        <a href="${item.link}" style="text-decoration:none" >
                            <p class="flexlistedocument__titre">${item.title}</p>
                        </a>
                        <div class="flexlistedocument__texte">${item.content}</div>
                        ${item.pdf ? "<p class='flexlistedocument__lien'><a href='" + item.pdf + "'>" + textCta + "</a></p>" : ""}
                    </li>
                `;
            bloc.liste.appendChild(li);
        });

        if (bloc.resultatLabel) {
            bloc.resultatLabel.innerHTML = this.results.length + " " + bloc.resultatLabel.dataset.label + (this.results.length > 1 ? "s" : "");
        }

        if (bloc.ctaMore) {
            if (this.results.length < (bloc.currentPage + 1) * bloc.NB_ITEMS_PER_PAGE) {
                bloc.ctaMore.parentElement.classList.add("flexlistedocument__plus--hidden");
            } else {
                bloc.ctaMore.parentElement.classList.remove("flexlistedocument__plus--hidden");
            }
        }
    }

    static normalise(string) {
        return string.toLowerCase().removeAccent();
    }
}

export default Filtre;


// WEBPACK FOOTER //
// ./src/scripts/components/filtre.js